import { toast } from "react-toastify";

import Dates from "../../../api/dates";

export const dates = {
  state: {
    dates: [],
  },
  reducers: {
    setDates(state, payload) {
      return {
        ...state,
        dates: payload,
      };
    },
    clearStore() {
      return {};
    },
  },
  effects: (dispatch) => ({
    async loadAvailableDatesAsync(payload, rootState) {

      try {
        const {
          idPlant,
          idProduct,
          idLoadType,
          clientDocumentNumber,
          transporterCNPJ
        } = payload;

        let data = [];
        const { timeBlocks: { blocks } } = rootState;

        if(blocks.length) {
          dispatch.timeBlocks.setBlocks([]);
        }

        if (payload) {
          const res = await Dates.listAvailableDates(
            idPlant,
            idProduct,
            idLoadType,
            clientDocumentNumber,
            transporterCNPJ
          );
          data = res.data;
        }
        this.setDates(data);
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
    },
  }),
};
